import React from 'react';

export default function FishermanHatSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="32.0,30.62 13.54,30.62 13.54,12.15 32.0,12.15" fill="#6A4023" />
      <polygon points="13.54,30.62 32.0,30.62 26.46,27.85 8.0,27.85" fill="#1D1109" opacity="0.95" />
      <polygon points="13.54,30.62 8.0,27.85 8.0,9.38 13.54,12.15" fill="#1D1109" opacity="0.95" />
      <polygon points="32.3,30.88 13.38,30.88 13.38,11.96 32.3,11.96" fill="#6A4023" />
      <polygon points="13.38,30.88 32.3,30.88 26.62,28.04 7.7,28.04" fill="#1D1109" opacity="0.95" />
      <polygon points="13.38,30.88 7.7,28.04 7.7,9.12 13.38,11.96" fill="#1D1109" opacity="0.95" />
      <polygon points="10.31,22.08 38.0,22.08 29.69,17.92 2.0,17.92" fill="#1D1109" opacity="0.95" />
    </svg>
  );
}
